module.exports = __webpack_public_path__ + "officialStatic/img/new13.6288001.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new13.jpg
// module id = +beM
// module chunks = 0